/**
 * IsoMap wired to gameStore — grid/violations/gameSpeed subscribe locally (perf).
 */
import React from 'react';
import { BuildingType } from '../types';
import { UndergroundLayer, LayerVisibility } from '../types/underground';
import { useGridState, useGameSpeed, useGameStore } from '../stores/gameStore';
import IsoMap from './IsoMap';

export type ConnectedIsoMapProps = {
  onTileClick: (x: number, y: number) => void;
  hoveredTool: BuildingType;
  selectedTile: { x: number; y: number } | null;
  onHoverTileChange?: (tile: { x: number; y: number } | null) => void;
  activeLayer: UndergroundLayer;
  layerVisibility: LayerVisibility;
  getPlacementError?: (x: number, y: number, tool: BuildingType) => string | null;
};

const ConnectedIsoMap: React.FC<ConnectedIsoMapProps> = ({
  onTileClick,
  hoveredTool,
  selectedTile,
  onHoverTileChange,
  activeLayer,
  layerVisibility,
  getPlacementError,
}) => {
  const grid = useGridState();
  const gameSpeed = useGameSpeed();
  const violationTiles = useGameStore((s) => s.violationTiles);

  return (
    <IsoMap
      grid={grid}
      onTileClick={onTileClick}
      hoveredTool={hoveredTool}
      selectedTile={selectedTile}
      onHoverTileChange={onHoverTileChange}
      violationTiles={violationTiles}
      paused={gameSpeed === 0}
      activeLayer={activeLayer}
      layerVisibility={layerVisibility}
      getPlacementError={getPlacementError}
    />
  );
};

export default React.memo(ConnectedIsoMap);